import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Formik} from "formik";
import ContactLoginView from "./ContactLogin-view";
import {checkRequiredValues} from 'common/utils/form/checkRequiredValues';

const ContactLogin = ({
                     sendContactMail,
                     showGlobalErrorMessage,
                     modalContactSlide,
                     slideModalContact
                }) => {
    const [reinit, setReinit] = useState(true);
    const initialValues = {
        fullName: '',
        email: '',
        message: ''
    };

    const validate = values => checkRequiredValues(values, {});

    const handleSubmit = (values, {resetForm}) => {resetForm()};

    const handleDataSubmit = values => () => {
        setReinit(false);  //https://github.com/formium/formik/issues/2369
        sendContactMail(values)
          .then(() => setReinit(true))
          .then(() => slideModalContact())
          .catch((err) => showGlobalErrorMessage(err.message))
    };

    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            onSubmit={handleSubmit}
            enableReinitialize={reinit}
            validateOnChange={true}
            validateOnBlur={false}
        >
            {(formikProps) => (
                <ContactLoginView
                  {...formikProps}
                  onSubmitClick={handleDataSubmit(formikProps.values)}
                  modalContactSlide={modalContactSlide}
                  slideModalContact={slideModalContact}
                />
              )}
        </Formik>
    )
};

ContactLogin.propTypes = {
    values: PropTypes.object,
    user: PropTypes.object
};

export default ContactLogin;
